<div class="modal-backdrop">
  <div class="modal-box">
    <div class="modal-body">
      <p class="join_meeting_heading">Join Meeting</p>

      <div class="zoom-notice" *ngIf="inAppBrowser">
        You opened this page inside another app (WhatsApp, Instagram, Facebook...). Zoom may not be able
        to use your microphone here. For the best experience open this page in Chrome or Safari.
        <button type="button" class="link-btn" (click)="copyPageLink()">
          {{ linkCopied ? 'Link copied' : 'Copy page link' }}
        </button>
      </div>

      <p class="join_meeting_quots">Please confirm your display name:</p>
      <fieldset>
        <legend>Display Name:</legend>
        <input type="text" class="input-data-display-name" required minlength="3" maxlength="254"
          [(ngModel)]="displayName" name="display_name" (keyup.enter)="join()">
      </fieldset>

      <button type="button" class="link-btn help-toggle" (click)="showHelp = !showHelp">
        <span *ngIf="showHelp">Hide help</span>
        <span *ngIf="!showHelp">Can't hear, speak or unmute?</span>
      </button>

      <div class="zoom-help" *ngIf="showHelp">
        <ol>
          <li>
            After joining, click <b>Join Audio</b> (or <b>Join Audio by Computer</b>) at the bottom-left of
            the Zoom screen. Until you do, the microphone icon stays crossed out.
          </li>
          <li>If the host has muted everyone, use <b>Raise Hand</b> and the host can let you speak.</li>
          <li *ngIf="browser === 'chrome' || browser === 'edge' || browser === 'other'">
            Joined in the browser: when it asks to use your microphone and camera, click <b>Allow</b>.
            If you clicked <b>Block</b> earlier: in the Zoom tab click the <b>lock icon</b> next to the address
            bar, then <b>Site settings</b>, set <b>Microphone</b> and <b>Camera</b> to <b>Allow</b>, and reload
            the Zoom tab.
          </li>
          <li *ngIf="browser === 'firefox'">
            Joined in Firefox: when it asks to use your microphone and camera, click <b>Allow</b>.
            If you blocked it earlier: click the <b>crossed-out microphone icon</b> in the address bar of the
            Zoom tab, clear the blocked permission, and reload the Zoom tab.
          </li>
          <li *ngIf="browser === 'safari' && platform === 'desktop'">
            Joined in Safari: when it asks to use your microphone and camera, click <b>Allow</b>.
            If you blocked it earlier: open <b>Safari &gt; Settings &gt; Websites &gt; Microphone</b> (and
            <b>Camera</b>), set <b>zoom.us</b> to <b>Allow</b>, and reload the Zoom tab.
          </li>
          <li *ngIf="platform === 'ios'">
            On iPhone/iPad in Safari: tap <b>aA</b> in the address bar of the Zoom tab, then
            <b>Website Settings</b>, set <b>Microphone</b> and <b>Camera</b> to <b>Allow</b>, and reload.
            In the Zoom app: <b>Settings &gt; Zoom</b>, turn on <b>Microphone</b>.
          </li>
          <li *ngIf="platform === 'android'">
            On Android in Chrome: tap the <b>icon left of the address</b> in the Zoom tab, then
            <b>Permissions</b>, and allow <b>Microphone</b> and <b>Camera</b>. In the Zoom app:
            <b>Settings &gt; Apps &gt; Zoom &gt; Permissions</b>, allow the microphone.
          </li>
          <li *ngIf="platform === 'desktop'">
            Check your computer allows the browser and the Zoom app to use the microphone: on Windows
            <b>Settings &gt; Privacy &gt; Microphone</b>, on Mac
            <b>System Settings &gt; Privacy &amp; Security &gt; Microphone</b>.
          </li>
        </ol>

        <div class="mic-test">
          <button type="button" class="zoom-btn" [disabled]="micTesting" (click)="testMicrophone()">
            {{ micTesting ? 'Testing...' : 'Test my microphone' }}
          </button>
          <p class="mic-result ok" *ngIf="micResult === 'ok'">Your microphone works. Allow it in Zoom too.</p>
          <p class="mic-result" *ngIf="micResult === 'denied'">
            Microphone is blocked. Allow it using the steps above, or check your device privacy settings.
          </p>
          <p class="mic-result" *ngIf="micResult === 'no-device'">No microphone was found on this device.</p>
          <p class="mic-result" *ngIf="micResult === 'busy'">
            Your microphone is being used by another app, or blocked by your device. Close other call apps
            and try again.
          </p>
          <p class="mic-result" *ngIf="micResult === 'unsupported' || micResult === 'error'">
            This browser cannot test the microphone. Try Chrome or Safari, or use the Zoom app.
          </p>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="join-btn-alert" (click)="close()">Close</button>
      <button class="join-btn-alert" [disabled]="!displayName?.trim()" (click)="join()">Join</button>
    </div>
  </div>
</div>
